const API_URL = `http://yesloyal-api.daken.ru`
const DOMAIN = '.yesloyal.daken.ru'

// const API_URL = `http://localhost:3000`
// const DOMAIN = '.yeslocal.com'
export {
  API_URL,
  DOMAIN,
}



// WEBPACK FOOTER //
// ./src/constants.js